import {
  AnyaAgentDetails,
  AnyaAgentDetailsState,
  AnyaAgentDetailsStatus,
  AnyaAgentFormValues,
  AnyaAgentSummary,
} from "./types";

type MaybeError = {
  message?: string;
  response?: {
    message?: string;
    data?: {
      message?: string;
    };
  };
};

export const EMPTY_ANYA_AGENT_FORM_VALUES = toFormValues();

export function getErrorMessage(error: unknown, fallback: string) {
  if (typeof error !== "object" || error === null) {
    return fallback;
  }

  const maybeError = error as MaybeError;

  return (
    maybeError.response?.data?.message ||
    maybeError.response?.message ||
    maybeError.message ||
    fallback
  );
}

export function toFormValues(agent?: {
  name?: string;
  description?: string;
  prompt?: string;
  context?: string[] | null;
}): AnyaAgentFormValues {
  const agentContext = agent?.context;
  const context = Array.isArray(agentContext) ? agentContext.slice() : [];

  return {
    name: agent?.name || "",
    description: agent?.description || "",
    prompt: agent?.prompt || "",
    context,
  };
}

export function toMutationPayload(values: AnyaAgentFormValues) {
  return {
    name: values.name.trim(),
    ...(values.description.trim()
      ? { description: values.description.trim() }
      : {}),
    prompt: values.prompt.trim(),
    context: normalizeContextItems(values.context),
  };
}

export function normalizeContextItems(context: string[] | null | undefined) {
  return Array.isArray(context)
    ? context.map((item) => item.trim()).filter(Boolean)
    : [];
}

export function getReadonlyFieldValues(params: {
  agent: AnyaAgentSummary | null;
  details: AnyaAgentDetails | undefined;
  formValues: AnyaAgentFormValues;
  isEditMode: boolean;
}): AnyaAgentFormValues {
  const { agent, details, formValues, isEditMode } = params;

  return {
    name: isEditMode ? formValues.name : details?.name || agent?.name || "",
    description: isEditMode
      ? formValues.description
      : details?.description || agent?.description || "",
    prompt: isEditMode ? formValues.prompt : details?.prompt || "",
    context: isEditMode ? formValues.context : details?.context || [],
  };
}

export function isDetailsLoaded(detailsState: AnyaAgentDetailsState) {
  return detailsState.status === AnyaAgentDetailsStatus.Success;
}
